import React, {Component} from "react"
import {connect} from "react-redux"
import {injectIntl} from 'react-intl'
import {Link} from 'react-router'
import {
  batchEnterpriseUserReport,
  queryCountries,
  queryEnterpriseAccount,
  queryInvitations,
  queryUserInfo,
  sendInvitation,
  setCurrentAccount,
  setCurrentApplication,
  showLicenseById,
  updateLicense
} from '../../dispatch'
import Papa from 'papaparse'
import {
  ButtonToolbar,
  Checkbox,
  DropdownButton,
  Glyphicon,
  InputGroup,
  Label,
  MenuItem,
  Tab,
  Tabs
} from 'react-bootstrap'
import {
  buildCsvContent,
  containsIgnoreCase,
  getCurrentLicense,
  getGender,
  getAvailableApplications,
  getLicenseFromApplicationName,
  convertOrder
} from '../../constants'
import {alertSuccess, alertWarning, confirm} from '../../util/AlertUtil'
import Spinner from '../../components/Spinner'
import ErrorAlert from '../../components/ErrorAlert'
import IBoxRow from '../../components/IBoxRow'
import PageBody from '../../components/PageBody'
import IBox from "../../components/IBox"
import {convertToDisplayFormat, parse} from '../../util/DateUtil'
import UserImage from "../../components/UserImage"
import {DebounceInput} from "react-debounce-input"
import moment from 'moment'
import noLogoImage from '../../images/neeuro_logo_square.jpg'
import UserFormModal from "./components/UserFormModal"
import LicenseDetailsModal from "./components/LicenseDetailsModal"
import EnterprisePageHeader from "./components/EnterprisePageHeader"
import EmailCheckingModal from "./components/EmailCheckingModal"

const papaConfig = {
  header: true,
  quotes: true,
  quoteChar: '"',
  delimiter: ",",
}

function mapStateToProps(state, ownProps) {

  const user = state.user
  const license = state.license
  const countries = state.countries
  const enterpriseAccount = state.enterpriseAccount

  const invitations = state.invitations

  return {
    router: state.router,
    user,
    license,
    countries,
    invitations,
    enterpriseAccount
  }
}

const mapDispatchToProps = {
  showLicenseById,
  queryUserInfo,
  queryCountries,
  setCurrentAccount,
  queryEnterpriseAccount,
  batchEnterpriseUserReport,
  setCurrentApplication,
  sendInvitation,
  queryInvitations,
  updateLicense
}


class AdminView extends Component {

  constructor(data) {
    super(data)

    this.state = {
      licenseDetailsModalOpen: false,
      checkEmailModalOpen: false,
      userModalOpen: false,
      selectedUserId: null,
      query: '',
      sort: 'name',
      order: 'asc',
      sortInvitations: 'name',
      orderInvitations: 'asc'
    }

  }

  openUserFormModal() {
    this.setState({userModalOpen: true, selectedUserId: null})
  }

  componentWillMount() {

    const accountId = this.props.user.currentEnterpriseAccount.id

    this.props.queryEnterpriseAccount(accountId)
    this.props.queryInvitations(accountId)
    this.props.queryCountries()

    const currentLicense = getLicenseFromApplicationName(this.props.user, 'cogoland')
    if (currentLicense)
      this.props.showLicenseById(currentLicense.id)
  }

  render() {



    const currentPath = this.props.router.locationBeforeTransitions.pathname

    const intl = this.props.intl
    const format = intl.formatMessage

    const accountId = this.props.user.currentEnterpriseAccount.id

    const license = this.props.license
    const user = this.props.user

    const authorizedUsers = op.get(this.props.enterpriseAccount, 'authorizedUsers', [])
    const invitations = this.props.invitations.data || []

    const sendInvitation = (userId, emailAddress) => {
      this.props.sendInvitation(accountId, [userId], license.id)
      setTimeout(() => {
        alertSuccess(
          format({id: 'alert.title.invitation.sent'}),
          format({id: 'alert.text.invitation.sent'}, {emailAddress}),
          ()=>{
            location.reload(true)
          }
        )
      }, 500)
    }

    const pendingInvitationMap = new Map()
    invitations.forEach((i) => {
      if (i.status === 'PENDING') {
        pendingInvitationMap.set(i.user.id, i)
      }
    })

    const authorizedUserIdSet = new Set()
    authorizedUsers.forEach((u) => {
      authorizedUserIdSet.add(u.id)
    })

    /*const usersWithLicense = authorizedUsers.filter((u) => {
     return u.existingLicenses.filter((l) => {
     return currentLicense && (l.id !== currentLicense.id) && (l.application.id === currentLicense.application.id)
     }).length > 0
     })*/
    const usersWithLicense = []

    const query = this.state.query

    const contains = containsIgnoreCase

    const filterUser = (u) => {
      return _.isEmpty(query) ?
        true
        :
        contains(u.emailAddress, query) || contains(u.name, query) || contains(u.enterpriseReference, query)
    }

    const usersAvailable = _.difference(authorizedUsers.filter(filterUser), usersWithLicense)

    const toLowerCase = (s) => (_.isNil(s) ? s : s.toLowerCase())

    usersAvailable.forEach((u) => {
      u.nameInLowerCase = toLowerCase(u.name)
    })


    const emailSet = new Set(license.emails)

    const {sort, order, sortInvitations, orderInvitations} = this.state

    const sortFunction = (sort) => {
      return (o) => {
        if (o[sort] && (sort === 'name' || sort === 'emailAddress')) return o[sort].toLowerCase()
        else return o[sort]
      }
    }

    let usersActive = _.sortBy(usersAvailable.filter((u) => emailSet.has(u.emailAddress)), [sortFunction(sort)])
    let usersInActive = _.sortBy(usersAvailable.filter((u) => !emailSet.has(u.emailAddress)), [sortFunction(sort)])

    if (order === 'desc') {
      usersActive = _.reverse(usersActive)
      usersInActive = _.reverse(usersInActive)
    }

    let sortedInvitations = _.sortBy(invitations.map((i) => {
      return Object.assign({nameInLowerCase: toLowerCase(i.user.name), emailAddress: i.user.emailAddress}, i)
    }), [sortFunction(sortInvitations)])
    if (orderInvitations === 'desc') {
      sortedInvitations = _.reverse(sortedInvitations)
    }

    const limit = !_.isNil(license.limit) ? license.limit : license.type ? license.type.limit : 0
    const usage = license.emails ? license.emails.length : 0

    const refMapActive = {}
    const refMapInActive = {}

    const countryMap = {}
    this.props.countries.data.forEach((it) => {
      countryMap[it.code] = it.label
    })

    const noUserSelectedAlert = () => alertWarning(format({id: 'no.user.selected'}))

    const addUserButton =
      <Link
        className="btn btn-primary pull-left"
        to={currentPath} onClick={() => {
        this.setState({checkEmailModalOpen: true})
      }}>
        {format({id: 'nav.add.user'})}
      </Link>

    const makeInactive = (users) => {
      const emails = _.difference(this.props.license.emails, users.map((u) => u.emailAddress))
      const licenseData = {
        id: license.id,
        emails
      }
      this.props.updateLicense(licenseData)
    }

    const makeActive = (users) => {
      const emails = _.concat(this.props.license.emails, users.map((u) => u.emailAddress))
      if (emails.length > limit)
        alertWarning('Active User Limit reached', `You cannot have more than ${limit} active users.`)
      else {
        const licenseData = {
          id: license.id,
          emails
        }
        this.props.updateLicense(licenseData)
      }
    }

    const search =
      <InputGroup>
        <InputGroup.Addon>
          <Glyphicon glyph="search"/>
        </InputGroup.Addon>
        <DebounceInput
          placeholder={`${format({id: 'admin.search'})} ...`}
          className="form-control input-sm"
          minLength={2}
          debounceTimeout={300}
          onChange={event => this.setState({query: event.target.value})}/>
      </InputGroup>


    const invitationTemplate = (invitation) => {

      const u = invitation.user

      const isAuthorized = invitation.status === 'AUTHORIZED'
      const colorMap = {
        'PENDING': 'primary',
        'AUTHORIZED': 'success',
        'DECLINED': 'warning',
        'FAIL': 'danger',
        'REVOKED': '',
      }
      return (
        <div className="col-xs-12">
          <div className="user-box" style={{paddingBottom: 0}}>
            <div className="col-sm-1 text-center">

            </div>
            <div className="col-sm-2">
              <UserImage className="m-t-sm m-b-sm" path={u.profileImagePath}/>
            </div>
            <div className="col-sm-4 p-h-md">
              <h3>{u.name}</h3>
              <p><i className="fa fa-envelope"/> {u.emailAddress} </p>
              <p><i className="fa fa-book"/> {u.enterpriseReference} </p>
            </div>
            <div className="col-sm-5 p-h-md text-right">
              <div className="row">
                <div className="col-xs-4">
                  <p className="m-t-sm text-center"><Label
                    bsStyle={colorMap[invitation.status]}>{format({id: `invitation.status.${invitation.status}`})}</Label>
                  </p>
                </div>
                <div className="col-xs-5 text-center">
                  <h4 className="m-t-sm">{convertToDisplayFormat(invitation.dateLastRequest)}</h4>
                </div>
                <div className="col-xs-3 text-center">
                  <div
                    onClick={() => {
                      if (isAuthorized) return
                      const lastRequest = parse(invitation.dateLastRequest).fromNow()
                      confirm(
                        format({id: 'confirm.title.invitation.pending'}),
                        format({id: 'confirm.text.invitation.pending'}, {time: lastRequest}),
                        format({id: 'invite.user'}),
                        () => {
                          sendInvitation(u.id, u.emailAddress)
                        }
                      )

                    }}
                    className={`custom-link btn btn-primary ${!isAuthorized ? '' : 'disabled'}`}>{format({id: 'resend.invitation'})}</div>
                </div>
              </div>
            </div>


            <div className="clearfix"></div>
          </div>
        </div>
      )
    }

    const userTemplate = (u, refMap) =>
      <div className="col-xs-12">
        <div className="user-box" style={{paddingBottom: 0}}>
          <div className="col-sm-1 text-center">
            <Checkbox className="m-t-xl m-b-xl"
                      inline inputRef={ref => refMap[u.id] = ref}/>
          </div>


          <div className="custom-link"
               onClick={() => {
                 this.setState({userModalOpen: true, selectedUserId: u.id})
               }}>

            <div className="col-sm-8 p-h-md">
              <h3>{u.name}</h3>
              <p><i className="fa fa-envelope"/> {u.emailAddress} </p>
              <p><i className="fa fa-book"/> {u.enterpriseReference} </p>
            </div>
            <div className="col-sm-3 p-h-md text-right">
              <h4 className="m-r-md">{convertToDisplayFormat(u.dateActivated)}</h4>
            </div>
          </div>

          <div className="clearfix"></div>
        </div>
      </div>

    let body = <div></div>

    const selectAllCheckbox = (map) => (
      <Checkbox className="m-t-xs"
                onChange={(e) => {
                  Object.keys(map).forEach((key) => {
                    map[key].checked = e.target.checked
                  })
                }}
                inline/>
    )

    const sortDropdownInvitations =
      <div>
        <ButtonToolbar>

          <i style={{cursor: 'pointer'}}
             onClick={() => {
               const order = this.state.orderInvitations
               if (order === 'asc') this.setState({orderInvitations: 'desc'})
               else this.setState({orderInvitations: 'asc'})
             }}
             className={`m-t-sm pull-right fa fa-lg fa-sort-${convertOrder(this.state.orderInvitations)}`}></i>

          <div className="pull-right">
            <DropdownButton noCaret
                            style={{border: '0px'}}
                            title={
                              format({id: 'dropdown.sort.by'}, {
                                field: format({id: this.state.sortInvitations}),
                                order: format({id: this.state.orderInvitations})
                              })
                            }
            >
              <MenuItem onSelect={() => {
                this.setState({sortInvitations: 'nameInLowerCase'})
              }}>{format({id: 'name'})} </MenuItem>
              <MenuItem onSelect={() => {
                this.setState({sortInvitations: 'emailAddress'})
              }}>{format({id: 'emailAddress'})} </MenuItem>
              <MenuItem onSelect={() => {
                this.setState({sortInvitations: 'dateLastRequest'})
              }}>{format({id: 'dateLastRequest'})}</MenuItem>

            </DropdownButton>
          </div>

        </ButtonToolbar>

      </div>

    const sortDropdown =
      <div>
        <ButtonToolbar>

          <i style={{cursor: 'pointer'}}
             onClick={() => {
               const order = this.state.order
               if (order === 'asc') this.setState({order: 'desc'})
               else this.setState({order: 'asc'})
             }}
             className={`m-t-sm pull-right fa fa-lg fa-sort-${convertOrder(this.state.order)}`}></i>

          <div className="pull-right">
            <DropdownButton noCaret
                            style={{border: '0px'}}
                            title={
                              format({id: 'dropdown.sort.by'}, {
                                field: format({id: this.state.sort}),
                                order: format({id: this.state.order})
                              })
                            }
            >
              <MenuItem onSelect={() => {
                this.setState({sort: 'nameInLowerCase'})
              }}>{format({id: 'name'})} </MenuItem>
              <MenuItem onSelect={() => {
                this.setState({sort: 'emailAddress'})
              }}>{format({id: 'emailAddress'})} </MenuItem>
              <MenuItem onSelect={() => {
                this.setState({sort: 'dateActivated'})
              }}>{format({id: 'dateActivated'})}</MenuItem>

            </DropdownButton>
          </div>

        </ButtonToolbar>

      </div>
    if (license && license.loading) {
      body = <Spinner show={license.loading}/>
    }else if (license && license.isValid) {


      const userDataForCSV = _.sortBy(authorizedUsers, (u) => u.name ? u.name.toLowerCase() : '').map((u) => {
        return {
          'Name': u.name,
          'Email': u.emailAddress,
          'Gender': getGender(u.isMale, intl),
          'Date of Birth': u.dob ? moment(u.dob, 'MMYYYY').format('MMM-YYYY') : '',
          'Education': u.education ? format({id: `education.${u.education}`}) : '',
          'Country': countryMap[u.country] ? countryMap[u.country] : '',
          'Status': emailSet.has(u.emailAddress) ? format({id: `active`}) : format({id: `inactive`}),
          'Reference': u.enterpriseReference,
        }
      })

      let csvContent = buildCsvContent(Papa.unparse(userDataForCSV, papaConfig))

      body = (
        <div className="m-t-lg">
          <ErrorAlert error={license.error}/>


          <IBox>
            <div className="row">
              <div className="col-sm-12">
                {format({id: 'license.usage'}, {usage: `${usage}`, limit: `${limit}`})}
                {/*<a className="m-l-sm" onClick={() => {
                  this.setState({licenseDetailsModalOpen: true})
                }}>
                  {format({id: `view.details`})}
                </a>*/}
              </div>
            </div>

            <hr className="hr-line-solid"></hr>

            <div className="row">
              <div className="col-sm-8">
                {search}
              </div>
              <div className="col-sm-4">
                {/*<div className="pull-right">
                  <a href={csvContent}
                     className="btn btn-primary"
                     download="Users.csv">Export All</a>
                </div>*/}
              </div>

            </div>
          </IBox>

          <div className="tabs-container">

            <Tabs defaultActiveKey={1}>
              <Tab eventKey={1} title={format({id: 'enterprise.active.users'})}>

                <div className="row m-l-none m-r-none white-bg">


                  <div className="col-xs-12 m-t-lg m-b-md">
                    <div className="user-box" style={{border: 0, paddingTop: 0, paddingRight: 0}}>
                      <div className="col-sm-1 text-center">
                        {selectAllCheckbox(refMapActive)}
                      </div>

                      <div className="m-t-xs col-xs-7">
                        <ButtonToolbar>

                          <DropdownButton title={format({id: 'dropdown.actions'})}
                                          bsStyle="primary">
                            <MenuItem onSelect={
                              () => {
                                const selectedUsers = usersActive.filter((u) => refMapActive[u.id].checked)
                                if (selectedUsers.length > 0)
                                  makeInactive(selectedUsers)
                                else
                                  noUserSelectedAlert()
                              }
                            }>{format({id: 'inactivate'})}</MenuItem>
                            <MenuItem onSelect={
                              () => {
                                const selectedUsers = usersActive.filter((u) => refMapActive[u.id].checked)

                                if (selectedUsers.length > 0) {
                                  this.props.batchEnterpriseUserReport(accountId, selectedUsers.map((u) => u.id), op.get(user, 'currentApplication.name'))
                                  alertSuccess(format({id:"batch.user.report.generation.modal.title"}),
                                    format({id:"batch.user.report.generation.modal.desc"}))
                                }
                                else
                                  noUserSelectedAlert()

                              }
                            }>{format({id: 'generate.reports'})}</MenuItem>

                          </DropdownButton>

                          {addUserButton}

                        </ButtonToolbar>

                      </div>

                      <div className="col-xs-4 text-right m-t-xs">
                        {sortDropdown}
                      </div>
                    </div>
                  </div>

                  {usersActive.map((u) => userTemplate(u, refMapActive))}
                </div>

              </Tab>
              <Tab eventKey={2} title={format({id: 'enterprise.inactive.users'})}>
                <div className="row m-l-none m-r-none white-bg">

                  <div className="col-xs-12 m-t-lg m-b-md">
                    <div className="user-box" style={{border: 0, paddingTop: 0, paddingRight: 0}}>
                      <div className="col-sm-1 text-center">
                        {selectAllCheckbox(refMapInActive)}
                      </div>

                      <div className="m-t-xs col-sm-7">
                        <ButtonToolbar>

                          <DropdownButton title={format({id: 'dropdown.actions'})}
                                          bsStyle="primary">
                            <MenuItem onSelect={
                              () => {
                                const selectedUsers = usersInActive.filter((u) => refMapInActive[u.id].checked)
                                if (selectedUsers.length > 0)
                                  makeActive(selectedUsers)
                                else
                                  noUserSelectedAlert()
                              }
                            }>{format({id: 'activate'})}</MenuItem>

                          </DropdownButton>
                          {addUserButton}
                        </ButtonToolbar>

                      </div>
                      <div className="col-sm-4 text-right m-t-xs">
                        {sortDropdown}
                      </div>
                    </div>
                  </div>

                  {usersInActive.map((u) => userTemplate(u, refMapInActive))}
                </div>

              </Tab>
              <Tab eventKey={3} title={format({id: 'status'})}>
                <div className="row m-l-none m-r-none white-bg">

                  <div className="col-xs-12 m-t-lg m-b-md">
                    <div className="user-box" style={{border: 0, paddingTop: 0, paddingRight: 0}}>
                      <div className="col-sm-1 text-center">
                        {/*{selectAllCheckbox(refMapInActive)}*/}
                      </div>

                      <div className="m-t-xs col-sm-7">
                        {/*<ButtonToolbar>

                            <DropdownButton title={format({id: 'dropdown.actions'})}
                                            bsStyle="primary">
                              <MenuItem onSelect={
                                () => {
                                  const selectedUsers = usersInActive.filter((u) => refMapInActive[u.id].checked)
                                  if (selectedUsers.length > 0)
                                    makeActive(selectedUsers)
                                  else
                                    noUserSelectedAlert()
                                }
                              }>{format({id: 'activate'})}</MenuItem>

                            </DropdownButton>
                            {addUserButton}
                          </ButtonToolbar>*/}

                      </div>
                      <div className="col-sm-4 text-right m-t-xs">
                        {sortDropdownInvitations}
                      </div>
                    </div>
                  </div>

                  {sortedInvitations.map((invitation) => invitationTemplate(invitation))}
                </div>

              </Tab>
            </Tabs>
          </div>

        </div>
      )

    } else {
      body = <IBoxRow>

        {license.error ?
          <ErrorAlert error={license.error}/>
          :
          format({id: "no.valid.license"})}
      </IBoxRow>
    }

    const logoPath = this.props.enterpriseAccount.logoPath ?
      this.props.enterpriseAccount.logoPath : noLogoImage

    const details = license.details || []
    if (details.length === 0) {
      details.push({
        limit,
        dateCreated: license.dateCreated,
        startDate: license.startDate,
        expirationDate: license.expirationDate,
      })
    }


    return <div>

      <LicenseDetailsModal
        details={details}
        limit={limit}
        show={this.state.licenseDetailsModalOpen}
        onHide={() => {
          this.setState({licenseDetailsModalOpen: false})
        }}
      />

      <EmailCheckingModal
        show={this.state.checkEmailModalOpen}
        onHide={() => {
          this.setState({checkEmailModalOpen: false})
        }}
        onUserExists={(emailAddress, userId) => {


          if (!authorizedUserIdSet.has(userId)) {
            const invitation = pendingInvitationMap.get(userId)

            if (invitation) {
              setTimeout(() => {
                const lastRequest = parse(invitation.dateLastRequest).fromNow()
                confirm(
                  format({id: 'confirm.title.invitation.pending'}),
                  format({id: 'confirm.text.invitation.pending'}, {time: lastRequest}),
                  format({id: 'invite.user'}),
                  () => {
                    sendInvitation(userId, emailAddress)
                  }
                )
              }, 500)

            } else {
              sendInvitation(userId, emailAddress)
            }


          } else {

            setTimeout(() => {
              alertWarning("User is already in your account.")
            }, 500)
          }
        }}
        onNewUser={(emailAddress) => {
          this.setState({defaultUserData: {emailAddress}})
          this.openUserFormModal()
        }
        }
      />

      <UserFormModal
        onHide={(dataSaved) => {
          this.setState({userModalOpen: false})

          if(dataSaved){
            setTimeout(()=>{location.reload(true)}, 500)
          }

        }}
        defaultData={this.state.defaultUserData}
        show={this.state.userModalOpen}
        id={this.state.selectedUserId}/>

      <EnterprisePageHeader
        title={format({id: 'nav.admin'})}
        subtitle={format({id: 'manage.your.users'})}
      />

      <PageBody>
        {body}
      </PageBody>
    </div>

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AdminView))



// WEBPACK FOOTER //
// ./src/routes/enterprise/AdminView.js